// extracted by mini-css-extract-plugin
module.exports = {"featuredHeader":"FeaturedHeader_featuredHeader__x_a5W","header":"FeaturedHeader_header__J8kMZ"};